import { TABLE_HEAD, TABLE_ROWS } from './repertuarData';

const Repertuar = () => {
    return (
        <div className="mx-auto px-4 sm:px-8 lg:px-16 xl:px-40 py-12 bg-[#111111]">
            <h1 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-center text-white mb-3 tracking-widest uppercase">
                Repertuar
            </h1>
            <div className="w-16 h-px bg-red-500 mx-auto mb-10" />

            {/* Mobile: karty */}
            <div className="flex flex-col gap-4 md:hidden">
                {TABLE_ROWS.map(({ name, miesiac, projekt, spetakl, date, locationName, locationLink, link, tekst }, index) => (
                    <div
                        key={index}
                        className="bg-[#161616] border border-white/8 rounded-xl p-5 flex flex-col gap-3"
                    >
                        <div className="flex items-center justify-between">
                            <div className="flex items-baseline gap-2">
                                <span className="text-4xl font-bold text-white leading-none">{name}</span>
                                <span className="text-sm text-gray-400 uppercase tracking-widest">{miesiac}</span>
                            </div>
                            {link ? (
                                <a href={link} target="_blank" rel="noopener noreferrer">
                                    <button className="text-xs font-semibold bg-red-500 hover:bg-red-600 text-white py-2 px-4 rounded-lg transition-colors duration-200 tracking-wider">
                                        ZAREZERWUJ
                                    </button>
                                </a>
                            ) : null}
                        </div>

                        {projekt && (
                            <p className="text-xs text-red-400 uppercase tracking-wider font-semibold">
                                {projekt}
                            </p>
                        )}

                        <div className="border-t border-white/5 pt-3 flex flex-col gap-1">
                            <p className="text-base font-semibold text-white">{spetakl}</p>
                            {locationLink ? (
                                <p className="text-sm text-gray-500">
                                    <a
                                        href={locationLink}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="hover:text-red-400 transition-colors"
                                    >
                                        {locationName}
                                    </a>
                                    {date && `, ${date}`}
                                </p>
                            ) : (
                                <p className="text-sm text-gray-500">{date}</p>
                            )}
                        </div>

                        {!link && tekst && tekst.trim() && (
                            <p className="text-xs text-gray-600">{tekst}</p>
                        )}
                    </div>
                ))}
            </div>

            {/* Desktop: tabela */}
            <div className="hidden md:block rounded-xl overflow-hidden border border-white/8">
                <table className="w-full min-w-max table-auto text-left">
                    <thead>
                        <tr className="bg-[#1a1a1a]">
                            {TABLE_HEAD.map((head) => (
                                <th key={head} className="border-b border-white/8 px-6 py-4">
                                    <p className="text-xs font-semibold text-gray-500 tracking-[0.2em] uppercase text-center">
                                        {head}
                                    </p>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {TABLE_ROWS.map(({ name, miesiac, projekt, spetakl, date, locationName, locationLink, link, tekst }, index) => {
                            const isLast = index === TABLE_ROWS.length - 1;
                            const rowBg = index % 2 === 0 ? 'bg-[#0d0d0d]' : 'bg-[#111111]';
                            const cell = isLast ? 'px-6 py-5' : 'px-6 py-5 border-b border-white/5';

                            return (
                                <tr key={index} className={`${rowBg} hover:bg-white/3 transition-colors duration-150`}>
                                    <td className={`${cell} border-b border-white/5`}>
                                        <p className="text-2xl lg:text-3xl font-bold text-white text-center leading-none">{name}</p>
                                        <p className="text-xs text-gray-500 text-center uppercase tracking-widest mt-1">{miesiac}</p>
                                    </td>
                                    <td className={cell}>
                                        <p className="text-sm lg:text-base text-gray-200 text-center">{spetakl}</p>
                                    </td>
                                    <td className={cell}>
                                        {projekt && (
                                            <p className="text-xs text-red-400 text-center font-semibold uppercase tracking-wider mb-1">{projekt}</p>
                                        )}
                                        {locationLink ? (
                                            <p className="text-sm text-gray-400 text-center">
                                                <a
                                                    href={locationLink}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="hover:text-red-400 transition-colors"
                                                >
                                                    {locationName}
                                                </a>
                                                {date && `, ${date}`}
                                            </p>
                                        ) : (
                                            <p className="text-sm text-gray-400 text-center">{date}</p>
                                        )}
                                    </td>
                                    <td className={`${cell} text-center`}>
                                        {link ? (
                                            <a href={link} target="_blank" rel="noopener noreferrer">
                                                <button className="text-xs font-semibold bg-red-500 hover:bg-red-600 text-white py-2 px-5 rounded-lg transition-colors duration-200 tracking-wider">
                                                    ZAREZERWUJ
                                                </button>
                                            </a>
                                        ) : (
                                            <p className="text-xs text-gray-600">{tekst}</p>
                                        )}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Repertuar;
